import { Loader2 } from "lucide-react";
import { QueryClient } from "@tanstack/react-query";
import { createRouter } from "@tanstack/react-router";
import { routeTree } from "./routeTree.gen";

export const getRouter = () => {
  const queryClient = new QueryClient();

  const router = createRouter({
    routeTree,
    context: { queryClient },
    scrollRestoration: true,
    // Full-reload navigation (see src/components/HardNavigation.tsx) means
    // client-side route preloading would just waste bandwidth — the browser
    // fetches fresh HTML from the edge cache on every click.
    defaultPreload: false,
    defaultPreloadStaleTime: 0,
    defaultPendingMs: 50,
    defaultPendingMinMs: 200,
    defaultPendingComponent: () => (
      <div className="fixed inset-x-0 top-0 z-50 flex items-center justify-center gap-2 bg-background/80 backdrop-blur px-4 py-2 text-xs font-medium text-muted-foreground border-b border-border">
        <Loader2 className="h-3.5 w-3.5 animate-spin" />
        Loading rates…
      </div>
    ),
  });

  return router;
};
